module.exports = __webpack_public_path__ + "intro-button-logout.6cf4249a.png";